// src/components/sonstige/Body_send_text.js
import React, { useState } from 'react';
import '../styles/sonstige/send-text.css';

function Body_send_text() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);

        try {
            const res = await fetch('https://nurleder.de/api/send-message/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData),
                credentials: 'omit'  // <-- Wichtig für CSRF-freie API
            });

            const data = await res.json();

            if (res.ok) {
                setStatus({ success: true, message: data.message || 'Nachricht erfolgreich gesendet ✅' });
                setFormData({ name: '', email: '', subject: '', message: '' });
            } else {
                setStatus({ success: false, message: data.error || '❌ Fehler beim Senden.' });
            }
        } catch (err) {
            console.error('❌ Netzwerkfehler:', err);
            setStatus({ success: false, message: '❌ Netzwerkfehler. Bitte erneut versuchen.' });
        }
    };

    return (
        <div className="contact-form-container">
            <h2>Kontaktformular</h2>
            <form onSubmit={handleSubmit} className="contact-form">
                <input
                    type="text"
                    name="name"
                    placeholder="Ihr Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Ihre E-Mail-Adresse"
                    value={formData.email}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="subject"
                    placeholder="Betreff"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                />
                <textarea
                    name="message"
                    placeholder="Ihre Nachricht..."
                    value={formData.message}
                    onChange={handleChange}
                    rows={6}
                    required
                ></textarea>

                <button type="submit">Absenden</button>

                {status && (
                    <p className={`status-message ${status.success ? 'success' : 'error'}`}>
                        {status.message}
                    </p>
                )}
            </form>
        </div>
    );
}

export default Body_send_text;
